import { dataKeys } from './descriptions';

// Parametro 1: Pergunta principal
// Parametro 2: Resposta da pergunta principal
export const getItens = (pergunta, resposta) => {
  const resItens = [];

  resposta?.map(res => {
    const filterResult = dataKeys[pergunta].opcoes.filter(
      item => item.valor === res
    );

    resItens.push({
      nome: filterResult[0]?.nomeHtml,
      posicao: filterResult[0]?.posicao,
    });
  });

  return resItens;
};

// Função exclusiva para o item 29 do perfil
export const getItensDiagnostico = (pergunta, resposta) => {
  const resItens = [];

  resposta?.map(res => {
    const filterResult = dataKeys[pergunta].opcoes.filter(
      item => item.valor === res
    );

    resItens.push({
      nome: filterResult[0]?.nomeHtml,
      posicao: filterResult[0]?.posicao,
    });
  });

  return resItens;
};

// Parametro 1: Pergunta principal
// Parametro 2: Resposta da pergunta principal
// Parametro 3: Respostas dos subitens
export const getSubItens = (pergunta, resposta, respostas) => {
  const resItens = [];

  respostas?.map(res => {
    const filterResult = dataKeys[pergunta].opcoes[resposta].subItens.filter(
      item => item.valor === res
    );

    // resItens.push(filterResult[0]?.nomeHtml);

    resItens.push({
      nome: filterResult[0]?.nomeHtml,
      posicao: filterResult[0]?.posicao,
    });
  });

  return resItens;
};
